const Footer = () => {
  return (
    <footer>
      <div className="nutritionix">
        <a href="https://www.nutritionix.com/">Powered by Nutritionix</a>
      </div>
      <p>
        Made at <a href="https://junocollege.com/">Juno College</a> by <a href="https://github.com/Aaron-Hoffman">Aaron
        Hoffman</a>, <a href="https://github.com/dlmcivor">Dana McIvor</a>, <a href="https://github.com/WuPaulo">Paulo Wu</a> & <a href="https://github.com/shanelbb">Shanel Beebe</a> 
      </p>
    </footer>
  );
};

export default Footer;
